import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {AdditionalConfigValidationFunctions, ConfigValidationFunction} from '../StepConfigValidationTypes';

const MISSING_PLATE_DIMENSIONS_ERROR = 'Select a plate design template or plate size.';

const validateConfig: ConfigValidationFunction<PipelineStepType.FILL_PLATE, 0> = (config) => {
  const hasPlateDesignTemplate = config.plateDesignTemplateId != null;
  const hasPlateDimensions = config.plateHeight != null && config.plateWidth != null;

  return hasPlateDesignTemplate || hasPlateDimensions ? [] : [MISSING_PLATE_DIMENSIONS_ERROR];
};

export default {
  stepType: PipelineStepType.FILL_PLATE,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.FILL_PLATE, 0>;
